export const DEFAULT_FRAME_RATE = 25;
